import { frontendURL } from '../../../helper/URLHelper';
import ContactsIndex from './pages/ContactsIndex.vue';
import ContactManageView from './pages/ContactManageView.vue';
import ContactImports from './pages/ContactImports.vue';
import ContactExports from './pages/ContactExports.vue';
import ConversationMigration from './pages/ConversationMigration.vue';
import ContactConsents from './pages/ContactConsents.vue';
import ContactsMap from './pages/ContactsMap.vue';

const commonMeta = {
  permissions: ['administrator', 'agent', 'contact_manage'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/contacts/exports'),
    name: 'contacts_exports',
    component: ContactExports,
    meta: { ...commonMeta, permissions: ['administrator'] },
  },
  {
    path: frontendURL('accounts/:accountId/contacts'),
    component: ContactsIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'contacts_dashboard_index',
        component: ContactsIndex,
        meta: commonMeta,
      },
      {
        path: 'segments/:segmentId',
        name: 'contacts_dashboard_segments_index',
        component: ContactsIndex,
        meta: commonMeta,
      },
      {
        path: 'labels/:label',
        name: 'contacts_dashboard_labels_index',
        component: ContactsIndex,
        meta: commonMeta,
      },
      {
        path: 'active',
        name: 'contacts_dashboard_active',
        component: ContactsIndex,
        meta: commonMeta,
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/contacts/imports'),
    name: 'contacts_imports',
    component: ContactImports,
    meta: {
      ...commonMeta,
      permissions: ['administrator'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/contacts/migration'),
    name: 'contacts_conversation_migration',
    component: ConversationMigration,
    meta: {
      ...commonMeta,
      permissions: ['administrator'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/contacts/consents'),
    name: 'contacts_consents',
    component: ContactConsents,
    meta: {
      ...commonMeta,
      permissions: ['administrator'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/contacts/map'),
    name: 'contacts_map',
    component: ContactsMap,
    meta: {
      ...commonMeta,
      permissions: ['administrator', 'contact_manage'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/contacts/:contactId'),
    component: ContactManageView,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'contacts_edit',
        component: ContactManageView,
        meta: commonMeta,
      },
      {
        path: 'segments/:segmentId',
        name: 'contacts_edit_segment',
        component: ContactManageView,
        meta: commonMeta,
      },
      {
        path: 'labels/:label',
        name: 'contacts_edit_label',
        component: ContactManageView,
        meta: commonMeta,
      },
    ],
  },
];
